import React, { createContext, useCallback, useContext, useState } from "react";

import { Fleet } from "../../../../../../../../models/fleet";

type EquipmentKeys = "all" | keyof Fleet;

interface EquipmentContextProps {
  equipment: Fleet;
  setEquipment: React.Dispatch<React.SetStateAction<Fleet>>;
  onUpdateEquipment: (attribute: EquipmentKeys, value: any) => void;
}

const EquipmentContext = createContext<EquipmentContextProps>({} as EquipmentContextProps);

const EquipmentProvider: React.FC = ({ children }) => {
  const [equipment, setEquipment] = useState<Fleet>({} as Fleet);

  const onUpdateEquipment = useCallback((attribute: EquipmentKeys, value: any) => {
    if (attribute && attribute !== "all") {
      if (!["string", "number", "boolean", "object"].includes(typeof value))
        setEquipment((state) => ({ ...state, [attribute]: [...value] }));
      else setEquipment((state) => ({ ...state, [attribute]: value }));
    } else {
      setEquipment({ ...value });
    }
  }, []);

  return (
    <EquipmentContext.Provider
      value={{
        equipment,
        setEquipment,
        onUpdateEquipment,
      }}
    >
      {children}
    </EquipmentContext.Provider>
  );
};

const useEquipmentContext = () => {
  const context = useContext(EquipmentContext);

  return context;
};

export { EquipmentProvider, useEquipmentContext };
